// these work correctly with videos received from media server
// for general use with all possible url formats (included querry strings etc.)
// these functions should be modified and tested

import { Job } from 'src/app/models/job.model';

export function getVideoNameFromUrl(videoUrl: string): string {
  const urlSegments = videoUrl.split('/');
  return urlSegments[urlSegments.length - 1];
}

export function getVideoMimeTypeFromFileName(videoFileName: string): string {
  const fileNameSegments = videoFileName.split('.');
  return fileNameSegments[fileNameSegments.length - 1];
}

export function changeVideoExtension(videoUrl: string, extension: string): string {
  const videoName = getVideoNameFromUrl(videoUrl);
  const videoExtension = getVideoMimeTypeFromFileName(videoName);
  return videoUrl.replace(`.${videoExtension}`, `.${extension}`);
}

export function setVideoExtenxions(job: Job): void {
  job.videoPosterUrl = changeVideoExtension(job.video, 'jpg');
  job.videoMp4Url = changeVideoExtension(job.video, 'mp4');
}
